import ApiConstant from "../../../constants/api.constants";
import Helpers from "../../../utils/helpers";
import api from "../../api";

const baseURL = process.env.REACT_APP_SERVER_ENDPOINT_AURA_CAMERA; 

const getSurveyInformation = async (cameraSiteId:any,surveyDate:any,siteName:any) => {
  try {
    const response = await api.get(`${baseURL}${ApiConstant.getSurveyInformation}?cameraSiteId=${cameraSiteId}&surveyDate=${surveyDate}&siteName=${siteName}`);
    if (response && response.data ) {
      return response.data;
    }
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
}; 
const getSurveyOverviewSummary = async (cameraSiteId:any,surveyDate:any,siteName:any) => {
  try {
    const response = await api.get(`${baseURL}${ApiConstant.getSurveyOverview}?cameraSiteId=${cameraSiteId}&surveyDate=${surveyDate}&siteName=${siteName}`);
    if (response && response.data ) {
      return response.data;
    }
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const getSurveyHistory = async (cameraSiteId:any) => {
  try {
    const response = await api.get(`${baseURL}${ApiConstant.getSurveyHistory}?cameraSiteId=${cameraSiteId}`);
    if (response && response.data ) {
      return response.data;
    }
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const SiteOperationsService = {
    getSurveyInformation,
    getSurveyOverviewSummary,
    getSurveyHistory
};

export default SiteOperationsService;
